var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"radio-index",class:{'disabled': _vm.disabled},style:({fontSize: `${_vm.size}px`}),on:{"click":_vm.onClick}},[(_vm.checked)?_c('i',{staticClass:"ri-icon el-icon-circle-check"}):_c('i',{staticClass:"ri-icon circle-no-check"}),_c('span',{staticClass:"ri-name",class:{checked: _vm.checked}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }